import type { ReactNode } from 'react'
import s from './Notice.module.css'

/** A whole-page message before the app opens: signing in, no access, the session ended. Actions are Buttons. */
export function Notice(props: { title: string; body?: string; children?: ReactNode }) {
  return (
    <main className={s.page}>
      <div className={s.notice} role="status">
        <span className={s.mark} aria-hidden="true" />
        <h1 className={s.title}>{props.title}</h1>
        {props.body && <p className={s.body}>{props.body}</p>}
        {props.children && <div className={s.actions}>{props.children}</div>}
      </div>
    </main>
  )
}
